import React from "react";

const Overview = ({formTitle}) => {
    return <div>{formTitle}</div>
}

export default Overview;